module.exports = __webpack_public_path__ + "static/media/pause_panning.63af9330.svg";